import { connect } from 'react-redux';
import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CloseIcon from '@mui/icons-material/Close';
import Toast from 'light-toast';
import { onAction } from '../../store/app/actions';

function Action({ ...props }) {
  const [anchorEl, setAnchorEl] = useState(props.anchorEl);
  const [actions, setActions] = useState('Action');

  const open = Boolean(anchorEl);

  const [state, setState] = useState({
    action: '',
    path: '',
    size: null,
  });

  const cancelPop = () => {
    setAnchorEl(null);
    props.onClose();
  };

  const handleActionChange = (e) => {
    setActions(e.target.value);
    setState((prev) => ({
      ...prev,
      action: e.target.value,
    }));
  };
  const handleTruncChange = (e) => {
    setState((prev) => ({
      ...prev,
      size: e.target.value,
    }));
  };
  const handlePathChange = (event) => {
    setState((prev) => ({
      ...prev,
      path: event.target.value,
    }));
  };

  // Handling the form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (state?.action === '' || state?.path === '') {
      Toast.fail('Please enter all details!');
    } else {
      onAction({ action: state?.action, path: state?.path, id: 's_' + props.id, size: state?.size });
      cancelPop();
    }
  };

  useEffect(() => {
    setAnchorEl(props.anchorEl);
  }, [props.anchorEl]);

  return (
    <>
      <Dialog id="create-popover" open={open}>
        <Box
          sx={{
            padding: '20px',
          }}
        >
          <div className="formTitle">
            <h3>Action Form </h3>
            <CloseIcon onClick={cancelPop} sx={{ cursor: 'pointer' }} />
          </div>

          <form>
            <div className="forminput">
              <label>Select Action </label>
              <span className="redstar">*</span>
              <FormControl sx={{ display: 'flex', minWidth: 140, backgroundColor: 'white' }} size="small" fullWidth>
                <InputLabel id="demo-simple-select-helper-label">Action</InputLabel>
                <Select
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="Action"
                  value={state?.action}
                  onChange={handleActionChange}
                >
                  <MenuItem value="delete">DELETE</MenuItem>
                  <MenuItem value="truncate">TRUNCATE</MenuItem>
                  <MenuItem value="command">COMMAND</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="forminput">
              <label>Enter Path</label>
              <span className="redstar">*</span>
              <TextField
                id="outlined-basic"
                onChange={handlePathChange}
                placeholder="Path"
                value={state?.path}
                variant="outlined"
              />
            </div>
            {actions === 'truncate' && (
              <div className="forminput">
                <label>Truncate Size</label>
                <span className="redstar">*</span>
                <TextField
                  id="outlined-basic"
                  onChange={handleTruncChange}
                  placeholder="Bytes"
                  value={state?.size}
                  variant="outlined"
                />
              </div>
            )}
            <button onClick={handleSubmit} style={{ float: 'right', marginTop: '5px' }}>
              {actions}
            </button>
          </form>
        </Box>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Action);
